export const BackgroundTexture = () => (
  <div
    className="fixed inset-0 z-0"
    style={{
      backgroundImage: 'url(https://customer-assets.emergentagent.com/job_purples/artifacts/ituj31qx_image.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed'
    }}
  />
);
